export const portalRoutes = [
  {
    path: '/portal-paciente',
    name: 'PortalPaciente',
    component: () =>
      import(/* webpackChunkName: "portal" */ '@/modules/Core/views/Index.vue'),
    icon: 'mdiCellphoneLink',
    typeIcon: 'mdi',
    menu: true,
    desplegable: true,
    meta: {
      title: 'Portal paciente',
      requiresSession: true,
      perfiles: ['ADMISIONES', 'ADMINISTRACION'],
      permiso: []
    },
    children: [
      {
        path: '/portal/solicitudes-perfil',
        name: 'SolicitudesPerfilPortal',
        component: () =>
          import(
            /* webpackChunkName: "portal" */ '@/modules/Portal/views/SolicitudesPerfilIndex.vue'
          ),
        icon: 'mdiAccountEditOutline',
        typeIcon: 'mdi',
        menu: true,
        desplegable: false,
        meta: {
          title: 'Solicitudes de edición',
          requiresSession: true,
          permiso: [],
          perfiles: ['ADMISIONES', 'ADMINISTRACION'],
          showBackButton: false
        },
        children: []
      },
      {
        path: '/portal/configuracion',
        name: 'ConfiguracionPortal',
        component: () =>
          import(
            /* webpackChunkName: "portal" */ '@/modules/Portal/views/ConfiguracionPortalIndex.vue'
          ),
        icon: 'mdiCogOutline',
        typeIcon: 'mdi',
        menu: true,
        desplegable: false,
        meta: {
          title: 'Configuración del portal',
          requiresSession: true,
          permiso: [],
          perfiles: ['ADMINISTRACION'],
          showBackButton: false
        },
        children: []
      }
    ]
  }
]
